import { motion } from "motion/react";
import { TbBriefcase } from "react-icons/tb";

import { ChooseShiftElements } from "@/pages/WelcomeTeam/components/ChooseShift";
import { useShiftActions } from "@/stores/use-shift";

const iconVariants = {
    initial: { opacity: 0, rotateY: 90 },
    animate: { opacity: 1, rotateY: 0 },
};
const textVariants = {
    initial: { opacity: 0, rotateX: 90 },
    animate: { opacity: 1, rotateX: 0 },
};
function LandingShiftChoose() {
    const { updateShiftDecision, updateShowStartShiftConfirmation, updateShowStartFreeDayConfirmation } =
        useShiftActions();

    const handleStartShift = (val?: boolean) => {
        updateShiftDecision();
        updateShowStartShiftConfirmation(val);
    };
    const handleFreeDay = (val?: boolean) => {
        updateShiftDecision();
        updateShowStartFreeDayConfirmation(val);
    };
    return (
        <>
            <div className="flex items-center ">
                <div>
                    <motion.div
                        variants={iconVariants}
                        initial="initial"
                        animate="animate"
                        transition={{ delay: 0.2, duration: 0.4 }}
                        className="mx-auto flex w-8 h-8  text-gray-500  shrink-0 items-center justify-center rounded-full cursor-pointer"
                    >
                        <TbBriefcase fontSize={18} />
                    </motion.div>
                </div>
                <motion.div
                    variants={textVariants}
                    initial="initial"
                    animate="animate"
                    transition={{ delay: 0.2, duration: 0.4 }}
                    className="font-semibold  text-gray-500 "
                >
                    Bugün Çalışıyor musunuz?
                </motion.div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-6    py-2 overflow-hidden max-w-full">
                <ChooseShiftElements handleFreeDay={handleFreeDay} handleStartShift={handleStartShift} />
            </div>
        </>
    );
}

export default LandingShiftChoose;
